"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _colors = require("../../config/colors");

var _config = require("../../config/config");

var NothingSelected = function NothingSelected() {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card, {
      style: {
        backgroundColor: _colors.SIDEBAR_BACKGROUND_COLOR
      },
      "data-cy": "nothing-selected"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Card.Body, null,
    /*#__PURE__*/
    _react["default"].createElement("h4", {
      className: "text-center sidebar-heading text-dark",
      style: {
        fontSize: '18px',
        letterSpacing: _config.ACCORDION_LETTER_SPACING,
        fontWeight: _config.ACCORDION_LETTER_WEIGHT
      }
    }, "Nothing selected."),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-center pt-4"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      size: "4x",
      color: "grey",
      icon: _proRegularSvgIcons.faFileSignature
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-center"
    },
    /*#__PURE__*/
    _react["default"].createElement("br", null), ' ', "Please select a field to make a change.")))
  );
};

var _default = exports["default"] = NothingSelected;